var map = {
	"./bg-dots.svg": 1152,
	"./favicon-32x32.png": 9900,
	"./icon-arrow.svg": 7967,
	"./icon-close.svg": 1924,
	"./icon-error.svg": 2108,
	"./icon-facebook.svg": 982,
	"./icon-hamburger.svg": 4422,
	"./icon-twitter.svg": 3989,
	"./illustration-features-tab-1.svg": 7130,
	"./illustration-features-tab-2.svg": 2709,
	"./illustration-features-tab-3.svg": 5257,
	"./illustration-hero.svg": 8406,
	"./logo-bookmark-2.svg": 6432,
	"./logo-bookmark-white.svg": 1931,
	"./logo-bookmark.svg": 3062,
	"./logo-chrome.svg": 8606,
	"./logo-firefox.svg": 1596,
	"./logo-opera.svg": 3807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;